<template>
  <div class="province-select">
    <div class="pro-area-select">
      <select v-model="site.province" @change="setProvince" class="province-select select" :style="option">
        <option
          v-for="(item, index) in provinceArr"
          :value="item.text"
          :key="index"
          class="select-option"
        >{{ item.text }}</option>
      </select>
      <span class="select-label" :style="cascaderLabelStyle">省</span>
    </div>
    <div class="pro-area-select">
      <select v-model="site.city" @change="setCity($event)" class="city-select select" :style="option">
        <option
          v-for="(item, index) in cityList"
          :value="item.text"
          :key="index"
          class="select-option"
        >{{ item.text }}</option>
      </select>
      <span class="select-label" :style="cascaderLabelStyle">市</span>
    </div>
    <div class="pro-area-select">
      <select v-model="site.area" @change="setArea($event)" class="area-select select" :style="option">
        <option
          v-for="(item, index) in areaList"
          :value="item.text"
          :key="index"
          class="select-option"
        >{{ item.text }}</option>
      </select>
      <span class="select-label" :style="cascaderLabelStyle">县/区</span>
    </div>
  </div>
</template>
<script>
import { areaList } from './area.js';
export default {
  name: 'CitySelect',
  props: ['siteInfo', 'option', 'cascaderLabelStyle'],
  data() {
    return {
      provinceArr: [],
      cityList: [],
      areaList: [],
      site: {
        province: '',
        city: '',
        area: '',
      },
    };
  },
  computed: {
  },
  watch: {
    siteInfo(val) {
      this.site = val;
      this.cityList;
      this.provinceArr.forEach((ele) => {
        if (ele.text === val.province) { // 判断与province是否相等，相等表示选中省份
          this.cityList = ele.children;
        }
      });
      if (this.cityList) {
        this.cityList.forEach((ele) => {
          if (ele.text === val.children) { // 判断与province是否相等，相等表示选中省份
            this.areaList = ele.children;
          }
        });
      }
    },
  },
  async mounted() {
    if (this.$isInEditor) return;
    this.useCascaderAreaData();
  },
  methods: {
    makeOption(text, value, children) {
      return {
        text,
        value,
        children,
      };
    },
    useCascaderAreaData() {
      const {
        city_list: city,
        county_list: county,
        province_list: province,
      } = areaList;
      const provinceMap = [];
      Object.keys(province).forEach((code) => {
        provinceMap.push(this.makeOption(province[code], code, []));
      });
      const cityMap = [];
      Object.keys(city).forEach((code) => {
        const option = this.makeOption(city[code], code, []);
        cityMap.push(option);

        const province = provinceMap.find(item => item.value.slice(0, 2) === code.slice(0, 2));
        if (province) {
          province.children.push(option);
        }
      });

      Object.keys(county).forEach((code) => {
        const city = cityMap.find(item => item.value.slice(0, 4) === code.slice(0, 4));
        if (city) {
          city.children.push(this.makeOption(county[code], code));
        }
      });
      this.provinceArr = provinceMap;
    },
    setProvince() {
      const that = this;
      let item;
      that.provinceArr.forEach((ele) => {
        if (ele.text === that.site.province) { // 判断与province是否相等，相等表示选中省份
          item = ele;
          console.log(ele);
        }
      });
      console.log(item);
      if (item) {
        this.cityList = item.children;  // 将选中的item的city省设置在cityList中 用于显示市
        this.areaList = []; // 清空区选中的值
        this.site.area = [];// 清空区选中的值
        this.$emit('setSite', '');
      }
      if (this.cityList.length <= 1) {
        this.site.city = item.children[0].text;
        this.areaList = item.children[0].children;  // 将选中的item的city省设置在cityList中 用于显示市
        this.$emit('setSite', '');
      }
    },
    setCity(e) {
      if (!e.target.value) {
        return;
      }
      const that = this;
      let item;
      that.cityList.forEach((ele) => {
        if (ele.text === that.site.city) { // 判断与city是否相等，相等表示选中区
          item = ele;
        }
      });
      if (item) {
        this.areaList = item.children;  // 将选中的item的city省设置在cityList中 用于显示市
        this.$emit('setSite', '');
      }
    },
    setArea(e) {
      if (!e.target.value) {
        return;
      }
      console.log(this.site, 'setSitesetSitesetSitesetSite');
      this.$emit('setSite', this.site);
    },
  },
};
</script>
<style lang="scss" scoped>
.province-select {
  display: flex;
  align-items: center;
}

.pro-area-select {
  position: relative;
  display: flex;
  align-items: center;
}

.pro-area-select::after {
  position: absolute;
  display: block;
  right: 0.2rem;
  top: 65%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0.15rem 0.1rem;
  border-color: #000 transparent transparent transparent;
  transform: translate(0, -50%);
  transform: translate(0, -50%);
  transform: translate(0, -50%);
  transform: translate(0, -50%);
  transform: translate(0, -50%);
  pointer-events: none;
}

.select {
  width: 100%;
  background: #f0f0f0;
  border: 0;
  // height: 0.6rem;
  text-align: center;
  font-size: 0.26rem;
  color: #000;
  appearance: none;
  display: block;
  outline: none;
}

.select::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0;
}

.select::-webkit-scrollbar {
  appearance: none;
  width: 5px;
  height: 5px;
}

.select::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}

.select::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.2);
}

.select::-webkit-scrollbar-track {
  width: 0.5px;
  border-radius: 0px;
  background: rgba(0, 0, 0, 0.2);
}

.province-select {
  // width: 1rem;
}

.city-select {
  // width: 1rem;
}

.select-label {
  margin: 0 5px;
}

.area-select {
  // width: 1rem;
}

.select-option {
  text-align: center;
}
</style>
